import { formValidation } from '../global/_formValidation';
import { addToWLPersonalizationTracking } from '../global/_personalization';
import { getAttrState } from '../modals_2017/_attrQVfunct';
import { wishListResponse, wishListJSONResponse } from './_wishListResponse.js';
import { scrollToATWLAlert } from './_scrollToATWLAlert';
import Cookies from 'js-cookie';
export const ajaxAddToWishlist = (params, returnHTML) => {
	formValidation();
	var form = $('#' + params.formId);
	if (form.find('.has-error').length == 0) {
		//Get current selected attrs/values and get that sku/catentryid number
		let curAttrStateSKU = getAttrState();
		let getDivSKUs = JSON.parse(document.getElementById('allSkus').innerText);
		const skuAllAttrVals = Object.values(getDivSKUs).filter(sku=>{
			return sku?.definingAttributes?.every(attribute =>{
				if(curAttrStateSKU[attribute.name]?.selectedValue && curAttrStateSKU[attribute.name]?.selectedValue != attribute.value.value){
					return false;
				}
				return true;
			})
		})		
		document.querySelector('#catEntryIdSKU').value = skuAllAttrVals[0].catentryId;
		const updateFormWithCategoryId = () => {
			let parentToLookForPersonalizationSuper = $('body');
			if ($('.quickview-image').length > 0) {
				parentToLookForPersonalizationSuper = $('.modal-body');
			}
			if (parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').length > 0 && parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').eq(0).html().length > 0) {
				document.querySelector('#FieldTwoForForm').value = parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').eq(0).html().trim()
			}
		}
		updateFormWithCategoryId()

		function loginThenAddToWishlist(baseURL) {
			var form = $('#' + params.formId);
			var outfitProductId = form.find(' :input[name=outfitPage]').length > 0 ? `&outfitProductId=${$('form#OrderItemAdd_0 :input[name=catEntryId]').val()}` : '';
			var protocol = 'https://';
			URL = `${protocol}${window.location.host}${baseURL}`;
			var prefix = 'wl';
			if (Modernizr.sessionstorage) {

				//get current state of attrs/values
				let curAttrState_Session = getAttrState();

				//build string with : and |
				let storageString = Object.values(curAttrState_Session).map(aVal => `${aVal.attrName}:${aVal.selectedValue}`).join('|');
					
				//if user didn't select anything
				if (storageString.length == 0) {
					sessionStorage.setItem(`${prefix}Attempt`, '-');
				} else {
					sessionStorage.setItem(`${prefix}Attempt`, storageString);
				}
				sessionStorage.setItem('attemptId', form.data('catentry'));
			}

			form.prop('action', URL);
			form.append("<input type='hidden' name='finalView' value='LogonForm' />");
			form.find(' :input[name=URL]').val('https://' + window.location.hostname + $('.quick-view-more').eq(0).attr('href'));
			form.find(' :input[name=rURL]').val('https://' + window.location.hostname + $('.quick-view-more').eq(0).attr('href'));
			form.find(' :input[name=rURL]').val(`InterestItemAdd?${form.serialize()}${outfitProductId}`);
			form.submit();
		}

		$('#addedToWishlist-alert, #addedToWishlist-error-alert, #addedToWishlist-lowqty-alert').fadeOut(3000);
		if (form.find('input[name=interestItemAddedFrom]').length == 0)
			form.append('<input type="hidden" name="interestItemAddedFrom" value="add-to-wishlist"' + params.formId + '" />');
		else form.find('input[name=interestItemAddedFrom]').val(params.formId);

		$("input[name='URL']").val('ProductDisplay');
		$("input[name='rURL']").val('ProductDisplay');

		//get current state of attrs/values
		let curAttrState = getAttrState();

		//build string with : and |
		const attr_String = Object.values(curAttrState).map(aVal => `${aVal.attrName}:${aVal.selectedValue}`).join('|');	

		form.find('.form-group').not('.quantity-container, .quantity-select')			
		form.append("<input type='hidden' name='field3' value='" + attr_String + "' id='FieldThreeForForm' />");
		var URL = '/webapp/wcs/stores/servlet/InterestItemAdd';
		addToWLPersonalizationTracking();

		//add ajaxparam for personalization merge
		//Protocol must be in the URL for IE9 to allow call to occur
		$.ajax({
			url: URL,
			cache: false,
			type: 'POST',
			data: form.serialize() + '&returnJSON=true',
			success: function (cmdResp) {
				var cmdRespIsJSON;
				try {
					var jsonResp = JSON.parse(cmdResp);
					cmdRespIsJSON = true;
				} catch (e) {
					console.log("e", e)
				}

				if (cmdRespIsJSON) {
					if (jsonResp.result == 'success') {
						wishListJSONResponse(jsonResp.interestItemAddedFrom, jsonResp.wlInventoryStatus, jsonResp.wlCatentryToAdd, jsonResp.field3);
					} else if (jsonResp.wishlistLimitReached == 'true') {
						$(
							'<div id="addedToWishlist-error-alert" class="alert alert-danger alert-dismissible" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToWishlist-alert-close-btn"><i class="fa fa-times"></i></button>You have reached the limit of items in your wishlist.<br><a data-twist="pd-click-here" href="/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1&orderId=.">Click here</a> to view your wish list</div>'
						).insertBefore('#add-to-wishlist');
					} else {
						$(
							'<div id="addedToWishlist-error-alert" class="alert alert-danger alert-dismissible" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToWishlist-alert-close-btn"><i class="fa fa-times"></i></button>There was an error adding this item to your wish list. Please try again later.</div>'
						).insertBefore('#add-to-wishlist');
					}
				} else {
					if ($(cmdResp).find('.verify-password').length > 0) {
						loginThenAddToWishlist('/webapp/wcs/stores/servlet/InterestItemAdd');
					} else if ($(cmdResp).find('.forgot-password').length > 0) {
						loginThenAddToWishlist('/webapp/wcs/stores/servlet/LogonForm');
					}
				}
				scrollToATWLAlert();
				$('#FieldThreeForForm').remove();
			},
			error: function () {
				var locationURL = 'https://' + window.location.host + '/webapp/wcs/stores/servlet/',
					// User is logged in and is on the check out page
					sprint687230 = Cookies.get('userInfo') && $('.checkout-pages').length > 0;
				if (!sprint687230) {
					if (String(window.location).indexOf('InterestItemDisplay') > 0) {
						window.location.reload();
						return;
					}

					form.append('<input type="hidden" name="finalView" value="LogonForm" />');
					form.find(' :input[name=URL]').val('InterestItemAdd?' + form.serialize());
					form.find(' :input[name=rURL]').val('InterestItemAdd?' + form.serialize());
					location.href = locationURL + 'LogonForm?' + form.serialize();
				} else location.href = locationURL + 'InterestItemDisplay?storeId=301&catalogId=301&langId=-1';
			},
		});
	}
};
